<template>

<v-navigation-drawer id="core-navigation-drawer" v-model="drawer" :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'" :right="$vuetify.rtl" :src="barImage" mobile-breakpoint="960" app width="260" v-bind="$attrs">
    <p />
    <v-btn style="left:210px; position:absolute; z-index:1000;" fab text left x-small v-if="drawer" v-tippy title="Ocultar Barra Lateral" @click="setDrawer(!drawer)">
        <v-icon small>mdi-arrow-expand-left</v-icon>
    </v-btn>
    <template v-slot:img="props">
        <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />

    </template>

    <v-list-item>
        <v-list-item-content>
            <v-list-item-title class="text-uppercase font-weight-regular display-2">
                <span class="logo-normal">
                    <img src="/static/small_full.png" height="64" alt="Power-CFDI" />
                </span>
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    <p />
    <v-divider class="mb-1" />

    <v-list expand nav>

        <template v-for="(item, i) in computedItems">
            <base-item-group style="text-decoration: none;" v-if="item.children" :key="`group-${i}`" :item="item">
                <!--  -->
            </base-item-group>

            <base-item style="text-decoration: none;" v-else :key="`item-${i}`" :item="item" />
        </template>

    </v-list>
    <v-divider />
    <v-card color="white" v-if="pagos.length > 0" elevation="5" class="pa-2">



        <v-card-text>
            <label style="color:green">Facturas de {{ pagos[0].RFC_RECEPTOR }}</label>
            <table class="table table-striped table-bordered table-condensed">
            <thead>
                <tr>
                    <th>Serie</th>
                    <th>Folio</th>
                    <th class="text-right">Total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="f in pagos" :key="f.index">
                    <td>{{f.SERIE}}</td>
                    <td>{{f.FOLIO}}</td>
                    <td class="text-right">{{f.TOTAL}}</td>
                </tr>
            </tbody>
        </table>
        </v-card-text>
        <v-card-actions class="text-right" >
            <v-spacer></v-spacer>
            <v-btn v-if="pagos.length>0" color="primary" small  @click="limpiar" title="Borrar Lista" v-tippy>  <v-icon small>mdi-trash-can-outline</v-icon></v-btn>
            <v-btn v-if="pagos.length>0 && url=='/notas'" color="pink" small  @click="crearnota" title="Crear Nota de Crédito" v-tippy>  <v-icon small>mdi-note-text</v-icon></v-btn>
            <v-btn v-if="pagos.length>0 && url=='/pagos'" color="purple" small  @click="crearpago" title="Crear Pago" v-tippy>  <v-icon small>mdi-cash</v-icon></v-btn>
        </v-card-actions>

    </v-card>


</v-navigation-drawer>



</template>

<script>
// Utilities
import {
    mapState,
    mapMutations
} from 'vuex'

export default {
    name: 'DashboardCoreDrawer',

    props: {
        expandOnHover: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {
        this.generamenu();
    },
    data: () => ({
        items: [],
        subitems: [],
        subitemsCaja: [],
        subitemsReportes: [],
    }),

    computed: {
        ...mapState(['barColor', 'barImage']),
        drawer: {
            get() {
                return this.$store.state.drawer
            },
            set(val) {
                this.$store.commit('SET_DRAWER', val)
            },
        },
        computedItems() {
            return this.items.map(this.mapItem)
        },
        tipo_usuario() {
            return this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("tipo_usuario")));
        },
        empresa() {
            return this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa")));
        },
        licencia() {
            return this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_licencia")));
        },
        pagos(){
             if(this.$local_storage.get('pagos') == undefined || this.$local_storage.get('pagos') == null)
                 return [];
             else
                return JSON.parse(this.$local_storage.get('pagos'));
        },
        url(){
            return this.$store.state.current_url;
        }
    },

    watch: {
        '$vuetify.breakpoint.smAndDown'(val) {
            this.$emit('update:expandOnHover', !val)
        },

    },

    methods: {
        ...mapMutations({
            setDrawer: "SET_DRAWER"
        }),
        mapItem(item) {
            return {
                ...item,
                children: item.children ? item.children.map(this.mapItem) : undefined,
                title: item.title,
            }
        },
        get_permiso(clave) {
            return this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256(clave))) == '1';
        },
        generamenu() {
            this.items = [];
            if (this.tipo_usuario == 1 && this.empresa == "" && this.licencia == "") {
                this.items = [{
                        icon: 'mdi-office-building-outline',
                        title: 'Empresas',
                        to: '/administracion/empresas',
                    },
                    {
                        icon: 'mdi-account-star',
                        title: 'Usuarios',
                        to: '/administracion/usuarios',
                    },
                    {
                        icon: 'mdi-close-octagon',
                        title: 'Errores WS',
                        to: '/administracion/errores',
                    },
                     {
                        icon: 'mdi-table',
                        title: 'Conteo',
                        to: '/conteo',
                    },
                    {
                        icon: 'mdi-login',
                        title: 'Acceder en Empresa',
                        to: '/administracion/accesos',
                    },
                ];
            }

            if (this.empresa != "") {

                if (this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('factura.nueva'))) == '1')
                    this.items.push({
                        to: '/newcartaporte',
                        icon: 'mdi-qrcode',
                        title: 'Nuevo CFDI',
                    });
                if (this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('factura.pagos'))) == '1')
                    this.items.push({
                        to: '/pagos',
                        icon: 'mdi-cash',
                        title: 'Nuevo Pago',
                    });
                if (this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('factura.notas'))) == '1')
                    this.items.push({
                        to: '/notas',
                        icon: 'mdi-note-text',
                        title: 'Nueva Nota de Crédito',
                    });
                if (this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('factura.borradores'))) == '1')
                    this.items.push({
                        to: '/pre_carta_porte',
                        icon: 'mdi-notebook-edit-outline',
                        title: 'Borradores CFDI',
                    });
                if (this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('factura.consulta'))) == '1'){
                    this.items.push({
                        to: '/cartaporte',
                        icon: 'mdi-format-list-checks',
                        title: 'Consultar CFDI',
                    });

                }
                if (this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('factura.reportes'))) == '1'){

                    this.items.push({
                        to: '/reportes/cfdi',
                        icon: 'mdi-file',
                        title: 'Reporte CFDI',
                    });
                     this.items.push({
                        to: '/reporteimpuestos',
                        icon: 'mdi-file',
                        title: 'Reporte Impuestos',
                    });

                }


                this.subitems = [];

                if (this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('catalogos.administrar'))) == '1') {
                    this.subitems.push({
                        icon: 'mdi-briefcase-account',
                        title: 'Clientes',
                        to: 'clientes',
                    });

                    this.subitems.push({
                        icon: 'mdi-circle-box',
                        title: 'Ubicaciones',
                        to: 'ubicaciones',
                    });
                    this.subitems.push({
                        icon: 'mdi-circle-box',
                        title: 'Figuras Transporte',
                        to: 'figurastransporte',
                    });
                    this.subitems.push({
                        icon: 'mdi-circle-box',
                        title: 'Transportes',
                        to: 'transportes',
                    });
                    this.subitems.push({
                        icon: 'mdi-circle-box',
                        title: 'Remolques',
                        to: 'remolques',
                    });

                    this.subitems.push({

                        icon: 'mdi-circle-box',
                        title: 'Productos',
                        to: 'articulos',
                    });

                    if (this.subitems.length > 0) {
                        this.items.push({
                            group: '/catalogos',
                            icon: 'mdi-folder-table-outline',
                            title: 'Catalogos',
                            visible: true,
                            children: this.subitems
                        });
                    }
                }

                this.subitems2 = [];

                if (this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('configuracion.administrar'))) == '1') {

                    this.subitems2.push({
                        icon: 'mdi-office-building-outline',
                        title: 'Datos Fiscales',
                        to: 'registros_fiscales',
                    });
                    this.subitems2.push({
                        icon: 'mdi-office-building-outline',
                        title: 'Usuarios',
                        to: 'usuarios',
                    });
                    if (this.subitems2.length > 0) {
                        this.items.push({
                            group: '/catalogos',
                            icon: 'mdi-tools',
                            title: 'Configuración',
                            visible: true,
                            children: this.subitems2
                        });
                    }
                }

            }

        },
        limpiar(){
            this.$local_storage.set("pagos","[]");
            this.$store.state.pagos = 0;
        },
        crearpago(){
            this.$local_storage.set('RFC_RECEPTOR', this.pagos[0].RFC_RECEPTOR);
            this.$router.replace("/newpagom");
        },
        crearnota(){
            this.$local_storage.set('RFC_RECEPTOR', this.pagos[0].RFC_RECEPTOR);
            this.$router.replace("/newnotam");
        }
    },
}
</script>



<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>

